<template>
    <div>
        <md-button class="md-raised md-primary" v-on:click="submit">抽選</md-button>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        name: "SubmitButton",
        methods: {
            submit: function () {
                axios.put(`https://afty.arukascloud.io/positions/${this.id}`, {members: this.checked})
            }
        },
        props: {
            checked: Array,
            id: String
        }
    }
</script>

<style scoped>

</style>
